import { Component, OnInit, ViewChild } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';
import { environment } from '../../../../environments/environment';
import { GeneralService } from 'src/app/services/service.index';
import { UtilHelper } from '../../../_helpers/util';

declare const toastr: any;
@Component({
  selector: 'app-escala',
  templateUrl: './escala.component.html',
  styleUrls: []
})
export class EscalaComponent implements OnInit {

  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;
  dataResourceEscala: any[];

  model: any = {
    id: 0,
    denominacion: '',
    unidad_medida_id: 0,
    activo: false,
    salario: 0,   

  };  

  techoId: number = 0;  
  popupVisibleAdd: boolean = false;
  popupVisibleDel: boolean = false;
  popupVisibleEstado: boolean = false;
  baseUrl = environment.apiEndpoint;
  hasError: any;
  vigencia: any[];
  state_toogle: boolean = false;
  constructor(private _gs: GeneralService) {
    this.vigencia = [{ text: 'Activo', value: true }, { text: 'Inactivo', value: false }];

  }

  ngOnInit() {
    this.getEscalas();
  }

  clearErrors() {
    this.hasError = { denominacion: false, salario: false, activo: false };
  }

  onToolbarPreparing(e) {
    e.toolbarOptions.items.unshift({
      location: 'before',
      template: 'acciones'
    },);
  }

  getEscalas() {
    this._gs.escalaSalarialActivos().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.dataResourceEscala = result.data;
        }
        else { this.dataResourceEscala = []; }
      },
      (error) => { console.log('Error', error); });
  }

  showModalAdd() {
    this.state_toogle = false;
    this.clearErrors();
    this.popupVisibleAdd = true;
    this.cleanModel();
  }

  cleanModel() {
    this.model = {
      id: 0,
      denominacion: '',
      unidad_medida_id: 0,
      activo: false,
      salario: 0,  

    };
  }

  saveEscala() {
    if (this.model.id == 0) {
      this.model.activo = true;
      this._gs.postEscala(this.model).subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.getEscalas();
            toastr.success('Observación registrada correctamente.');
            this.popupVisibleAdd = false;
          }
          else if (result.status == 201) {
            toastr.warning(result.data);
          }
        },
        error => { console.log('Error', error); });
    }
    else {
      this._gs.putEscala(this.model).subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.getEscalas();
            toastr.success('Observación registrada correctamente.');
            this.popupVisibleAdd = false;
          }
          else if (result.status == 201) {
            toastr.warning(result.data);
          }
        },
        error => { console.log('Error', error); });
    }
  }

  showModalEdit(data: any) {
    this.state_toogle = true;
    this.clearErrors();
    this.model.id = data.id;
    this.model.denominacion = data.denominacion;
    this.model.activo = data.activo;
    this.model.salario = data.salario;    
    this.popupVisibleAdd = true;
  }

  showModalDelete(id: number) {
    this.model.id = id;
    this.popupVisibleDel = true;
  }

  deleteEscala() {
    {
      this._gs.deleteEscala(this.model.id).subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.getEscalas();
            this.popupVisibleDel = false;
            toastr.success('Registro eliminado correctamente.');
          } else if (result.status == 201) {
            this.getEscalas();
            this.popupVisibleDel = false;
            toastr.warning(result.data);
          }
          else {
            toastr.warning("otro");
          }
        },
        error => { console.log('Error', error); });
    }
  }

}
